var map = {
	"./20455026602-logo.png": "./src/assets/images/20455026602-logo.png",
	"./20455166528-logo.png": "./src/assets/images/20455166528-logo.png",
	"./20539579356-logo.png": "./src/assets/images/20539579356-logo.png",
	"./20612699861-logo.png": "./src/assets/images/20612699861-logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync -logo\\.(png%7Cjpe?g)$/";